module.exports = __webpack_public_path__ + "img/mail-verif-ic.32820f82.svg";